/* EVERLA sales layer (2026-10-05). Loaded after everla-v2.js, whose public hooks it uses:
   [data-quick-add] buttons (add one variant, refresh and open the drawer) and [data-ev-cart] (open the drawer).
   1. Phone sticky add-to-cart: announce it only while it is shown, name the selected colour, follow the main button.
   2. Cart drawer add-ons: after every cart change, swap in a freshly rendered copy (section rendering API). It reuses
      the cart-drawer HTML that everla-v2.js already fetches for that change, so a change costs no extra request.
   3. Ships-free sets: add every piece in one /cart/add.js call, then hand over to everla-v2.js's afterAdd (it opens
      the drawer only on the first add of a visit, 2026-10-14); log the editor checks. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- 1. sticky add-to-cart (phone) ---------- */
  var sticky = $('.ev-sticky-atc');
  var pdp = $('[data-ev-pdp]');
  if (sticky && pdp) {
    var sBtn = $('button', sticky), sVar = $('[data-ev-sticky-variant]', sticky), sImg = $('[data-ev-sticky-img]', sticky);
    var sTitle = ($('.t b', sticky) || {}).textContent || '';
    var mainBtn = $('.atc', pdp), idInput = $('form[data-ev-atc] input[name=id]', pdp);
    var variants = [];
    try { variants = JSON.parse(($('[data-ev-variants]', pdp) || {}).textContent || '[]'); } catch (e) { variants = []; }
    var syncState = function () {
      var on = sticky.classList.contains('is-on');
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in sticky) sticky.inert = !on;
      document.body.classList.toggle('ev-sticky-on', on);
    };
    var syncVariant = function () {
      var vals = $$('.ev-opt .lb span', pdp).map(function (t) { return t.textContent.trim(); }).filter(Boolean);
      if (sVar) sVar.textContent = vals.length ? ' · ' + vals.join(' / ') : '';
      if (sBtn) sBtn.setAttribute('aria-label', (mainBtn ? mainBtn.textContent.trim() : 'Add to cart') + ': ' + sTitle + (vals.length ? ', ' + vals.join(', ') : ''));
      var id = idInput ? Number(idInput.value) : 0;
      var v = variants.filter(function (x) { return x.id === id; })[0];
      var src = v && v.featured_image && v.featured_image.src;
      if (sImg && src) { var u = new URL(src, location.href); u.searchParams.set('width', '120'); sImg.removeAttribute('srcset'); sImg.src = u.href; }
    };
    var syncButton = function () {
      if (!mainBtn || !sBtn) return;
      sBtn.disabled = mainBtn.disabled;
      sBtn.textContent = mainBtn.textContent;
      syncVariant();
    };
    new MutationObserver(syncState).observe(sticky, { attributes: true, attributeFilter: ['class'] });
    if (mainBtn) new MutationObserver(syncButton).observe(mainBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, characterData: true, subtree: true });
    pdp.addEventListener('click', function (e) { if (e.target.closest('.ev-opt')) setTimeout(syncVariant, 0); });
    syncState(); syncButton();
  }

  /* ---------- 2. cart drawer add-ons ---------- */
  var cartEl = $('.ev-cart[role="dialog"]');
  var cartItems = cartEl && $('.items', cartEl);
  if (cartEl && cartItems && $('[data-ev-addons]', cartEl)) {
    var seq = 0, timer = null;
    var domSig = function () {
      return $$('.line[data-key]', cartItems).map(function (l) { var q = $('.qty span', l); return l.getAttribute('data-key') + ':' + (q ? q.textContent.trim() : ''); }).join(',') + ($$('.line[data-key]', cartItems).length ? ',' : '');
    };
    /* everla-v2.js already asks Shopify for the cart-drawer section on every cart change (/cart?sections=cart-drawer
       after an add, /cart/change.js with sections: cart-drawer after a quantity change) but exposes neither the
       response nor an event. A read-only tap on fetch keeps a clone of those responses: the request itself goes
       through untouched and the caller gets the very same promise. The copy is used only when its add-ons block was
       rendered for the cart now on screen (same data-cart-sig); otherwise this falls back to one request of its own. */
    var lastHtml = null, lastRead = null;
    var keepHtml = function (j) { var h = j && (j['cart-drawer'] || (j.sections && j.sections['cart-drawer'])); if (typeof h === 'string') lastHtml = h; };
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input) {
        var p = nativeFetch.apply(window, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
          if (/\/cart(\?sections=[^#]*cart-drawer|\/change(\.js)?(\?|$))/.test(url)) {
            lastRead = p.then(function (r) { return r && r.ok ? r.clone().json().then(keepHtml) : null; }).catch(function () {});
          }
        } catch (e) {}
        return p;
      };
    }
    var parseAddons = function (html) { return $('[data-ev-addons]', new DOMParser().parseFromString(html, 'text/html')); };
    var swapAddons = function (fresh) {
      var now = $('[data-ev-addons]', cartEl);
      if (!fresh || !now) return;
      var hadFocus = now.contains(document.activeElement);
      now.replaceWith(fresh);
      if (hadFocus) {
        var next = fresh.hidden ? $('[data-ev-checkout]', cartEl) : $('[data-quick-add]', fresh);
        if (next) next.focus();
      }
    };
    var refreshAddons = function () {
      var current = $('[data-ev-addons]', cartEl);
      if (!current || current.getAttribute('data-cart-sig') === domSig()) return;
      var mine = ++seq;
      Promise.resolve(lastRead).then(function () {
        if (mine !== seq) return;
        var reused = lastHtml ? parseAddons(lastHtml) : null;
        if (reused && reused.getAttribute('data-cart-sig') === domSig()) { swapAddons(reused); return; }
        return fetch(root + 'cart?sections=cart-drawer')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (sections) {
            if (mine !== seq || !sections || !sections['cart-drawer']) return;
            swapAddons(parseAddons(sections['cart-drawer']));
          });
      }).catch(function () {});
    };
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refreshAddons, 60); }).observe(cartItems, { childList: true });
  }

  /* ---------- 3. ships-free sets: add the whole set ---------- */
  /* Editor checks from sections/ev-set.liquid (unknown colour, oversized piece, total under the threshold): console only. */
  $$('[data-ev-set][data-set-warn]').forEach(function (s) { if (window.console && console.warn) console.warn('EVERLA set check: ' + s.getAttribute('data-set-warn')); });
  var openDrawer = function () {
    var trigger = $('[data-ev-cart]');
    if (trigger && cartEl && !document.body.classList.contains('template-cart')) trigger.click();
    else location.href = root + 'cart';
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-set-add]'); if (!btn) return;
    e.preventDefault();
    var set = btn.closest('[data-ev-set]'); var msg = set && $('[data-set-msg]', set);
    var items = $$('[data-set-line]', set).map(function (l) {
      return { id: parseInt(l.getAttribute('data-vid'), 10), quantity: parseInt(l.getAttribute('data-qty'), 10) || 1 };
    }).filter(function (i) { return i.id > 0; });
    if (!items.length || btn.disabled) return;
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding the set…'; if (msg) msg.textContent = '';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        btn.textContent = 'Added to your cart';
        var v2 = window.EVERLAv2;
        if (v2 && v2.afterAdd && !document.body.classList.contains('template-cart')) v2.afterAdd(j && j.items, items); else openDrawer();
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200);
      })
      .catch(function (err) {
        if (msg) msg.textContent = (err && (err.description || err.message)) || 'We could not add the set. Please try again.';
        btn.textContent = label; btn.disabled = false;
      });
  });
})();
